import Group from "../Models/Group";
import HttpService from "../Services/HttpService";
import PlayerPair from "../Models/PlayerPair";
import UpdateGroupRequest from "../Requests/Groups/UpdateGroupRequest";

class GroupRepository
{
  public groups: Group[] = [];

  public async load(): Promise<Group[]>
  {
    const url = '/Group';
    this.groups = await HttpService.get<Group[]>(url);
    return this.groups;
  }

  public async delete(group: Group): Promise<void>
  {
    const url = `/Group/${group.id}`;
    await HttpService.delete<void>(url);
    await this.load();
  }

  public async update(group: Group): Promise<void>
  {
    const url = `/Group`;
    const body: UpdateGroupRequest = {
      id: group.id,
      enableSubtitles: group.enableSubtitles,
    };
    await HttpService.put<void>(url, body);
    await this.load();
  }

  public getById(id: string): Group | undefined
  {
    return this.groups
      .find((group: Group) => group.id === id);
  }

  public getPlayerPairById(id: string): PlayerPair | undefined
  {
    return this.groups
      .flatMap(x => x.playerPairs)
      .find(x => x.id == id)
  }
}

export const groupRepository = new GroupRepository();